import styled from 'styled-components';

export const ContentSelectorsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  gap: 24px;
`;
